import React, { useState } from 'react'
import { Button, ChevronLeftIcon, ChevronRightIcon } from '@diversioteam/diversio-ds'

import { withErrorBoundary } from 'config/withErrorBoundary/withErrorBoundary'

import { Announcements } from './Announcements'
import { Events } from './Events'
import { Solutions } from './Solutions'

import './index.scss'

const RightContentPanelWithoutEB = () => {
    const [isOpen, setIsOpen] = useState<boolean>(true)

    return (
        <div className="right-content-panel-container">
            <Button
                iconOnly
                onClick={() => {
                    setIsOpen(!isOpen)
                }}
            >
                {isOpen ? <ChevronRightIcon type="bold" /> : <ChevronLeftIcon type="bold" />}
            </Button>
            {isOpen ? (
                <div className="right-content-panel" data-joyride="right-content-panel">
                    <Events />
                    <Solutions />
                    <Announcements />
                </div>
            ) : null}
        </div>
    )
}

export const RightContentPanel = withErrorBoundary(RightContentPanelWithoutEB, {})
